// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"dee0e9fb","976":"eb6e09f3"}[chunkId] + ".chunk.js";
};